import { render, staticRenderFns } from "./king-form.vue?vue&type=template&id=58f22401&scoped=true"
import script from "./king-form.vue?vue&type=script&lang=js"
export * from "./king-form.vue?vue&type=script&lang=js"
import style0 from "./king-form.vue?vue&type=style&index=0&id=58f22401&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f22401",
  null
  
)

export default component.exports